export enum NotificationEventCategory {
  EMAIL = 'EMAIL',
  AUTO_SETUP = 'AUTO_SETUP',
  MANUAL_SETUP = 'MANUAL_SETUP',
}
